import { useRef } from 'react';
import { Accordion } from '@prosolve/common-components-ui'
// import AccountSelector from './AccountSelector';
import { FormField } from '@prosolve/common-components-ui'
import { getClientSubdomain } from '../../../../utils';

export default ({
  formData,
}) => {
  const clientSubdomain = getClientSubdomain()
    
  const isStarSubdomain = (clientSubdomain === 'star')

  const hasFilters = () => {
    return Object.values(formData.values).some(v => v !== '' && v != null && v !== undefined);
  }

  const itemsRef = useRef([]);
  const clearAll = () => {
    if (itemsRef && itemsRef.current && itemsRef.current.length > 0) {
      itemsRef.current.forEach(comp => {
        if (comp && comp.clearInput) {
          comp.clearInput();
        }
      });
    }
    const clearedValues = {}
    Object.keys(formData.values).forEach(key => {
      clearedValues[key] = '';
    })
    formData.setValues(clearedValues)
  }

  return (
    <div>
        <Accordion
          title={
            <div>
              <div
                style={{ 
                  textDecoration: 'underline', 
                  color: '#44ACE1', 
                  fontSize: '15px', 
                  fontStyle: 'italic',
                  textAlign: 'right',
                  marginRight: '10px'
                }}
              >
                {'Filters'}
              </div>
              {
                hasFilters() &&
                <span style={{
                  textDecoration: 'none',
                  marginLeft: '20px',
                  color: '#b1b5c4',
                  fontSize: '12px', 
                  fontStyle: 'italic',
                  whiteSpace: 'nowrap',
                  position: 'absolute',
                  top: '-15px',
                  right: '-10px'
                }}>
                  {'*Filters currently applied'}
                </span>
              }
            </div>
          }
          defaultOpen={hasFilters()}
          headerExpands={true}
          style={{ padding: '0px 5px 0px 5px', position: 'absolute', top: '20px', right: '20px' }}
          expandedStyle={{ padding: '20px 10px 0px' }}
        >
          <div style={{ 
            display: 'flex',
            gap: '20px',
            position: 'relative'
          }}>
            {/* <AccountSelector formData={formData} /> */}
            <FormField
              ref={comp => itemsRef.current[0] = comp} 
              style={{ flex: 2 }}
              width='100%'
              fieldId='account'
              type='text'
              label='Account'
              placeholder=''
              preventValueUpdate={true}
              formData={formData}
            />
            {isStarSubdomain && 
              <FormField
                ref={comp => itemsRef.current[0] = comp} 
                style={{ flex: 2 }}
                width='100%'
                fieldId='trainer'
                type='text'
                label='Trainer'
                placeholder=''
                preventValueUpdate={true}
                formData={formData}
              />
            }
            {isStarSubdomain && 
              <FormField
                ref={comp => itemsRef.current[0] = comp} 
                style={{ flex: 2 }}
                width='100%'
                fieldId='csSpecialist'
                type='text'
                label='CS Specialist'
                placeholder=''
                preventValueUpdate={true}
                formData={formData}
              />
            }
            <FormField
              ref={comp => itemsRef.current[1] = comp} 
              style={{ flex: 1 }}
              width='100%'
              fieldId='startDate'
              type='date'
              label='Start Date'
              placeholder=''
              formData={formData}
            />
            <FormField
              ref={comp => itemsRef.current[2] = comp} 
              style={{ flex: 1 }}
              width='100%'
              fieldId='endDate'
              type='date'
              label='End Date'
              placeholder=''
              formData={formData}
            />
            <div
              style={{
                textDecoration: 'underline',
                color: '#44ACE1',
                fontSize: '13px',
                fontStyle: 'italic',
                cursor: 'pointer',
                position: 'absolute',
                top: '0px',
                right: '5px'
              }}
              onClick={clearAll}
            >
              {'Clear All'}
            </div>
            {/* <FormField
              style={{ flex: 1 }}
              width='100%'
              fieldId='trainer'
              type='text'
              label='Trainer'
              placeholder=''
              formData={formData}
            /> */}
          </div>
        </Accordion>
    </div>
  )
}